import { useEffect, useState } from "react";

const LINES = [
  "Your words just helped a neighbour discover Punjab's food.",
  "Every review writes the next chapter of our story in this community.",
  "You just kept a small family kitchen cooking. That means everything.",
];

export const ReviewThanks = ({ open, onClose }) => {
  const [line, setLine] = useState(LINES[0]);
  useEffect(() => {
    if (!open) return;
    setLine(LINES[Math.floor(Math.random() * LINES.length)]);
    const t = setTimeout(onClose, 8000);
    return () => clearTimeout(t);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div data-testid="review-thanks" className="fixed inset-0 z-[90] bg-black/75 flex items-center justify-center px-6" onClick={onClose}>
      <div className="mascot-confetti absolute inset-0 pointer-events-none" aria-hidden="true">
        {Array.from({ length: 26 }).map((_, i) => (
          <span
            key={i}
            style={{
              left: `${(i * 37 + 5) % 100}%`,
              animationDelay: `${(i % 9) * 0.11}s`,
              background: ["#D4AF37", "#F0C742", "#E25822", "#FFFFFF"][i % 4],
            }}
          />
        ))}
      </div>
      <div
        className="review-thanks-pop relative rounded-3xl border border-[#D4AF37]/50 bg-gradient-to-br from-[#1F1A0C] to-[#121212] p-7 max-w-sm w-full text-center xp-card-shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <img src="/mascot/celebrate.png" alt="VeerGi celebrates" className="h-28 w-auto mx-auto"
          style={{ filter: "drop-shadow(0 6px 16px rgba(212,175,55,0.35))" }} />
        <p className="text-[10px] tracking-[0.3em] text-[#D4AF37] font-bold mt-3">SHUKRIYA, JI!</p>
        <p data-testid="review-thanks-line" className="font-display text-2xl font-bold leading-snug mt-1">{line}</p>
        <p className="text-sm text-white/60 mt-2">— VeerGi &amp; the Urban family</p>
        <button
          data-testid="review-thanks-close"
          onClick={onClose}
          className="mt-5 h-11 px-7 rounded-full bg-[#D4AF37] text-black font-bold text-xs tracking-widest hover:bg-[#F0C742] transition-colors"
        >
          BACK TO THE FOOD
        </button>
      </div>
    </div>
  );
};
